// client/src/coms/presence/QuickStatus.js
// Quick status in the account menu (your avatar, bottom of the channel list): one tap for Online, AFK, Do Not
// Disturb or Appear offline until you change it; "Set a duration…" opens the full setting.
import React, { useState } from 'react';
import { StatusDot } from './PresenceUi';
import { describeMine, useNow } from './PresenceStatusSetting';
import { setMyStatus, usePresence } from './presenceClient';

const QUICK = [
  ['online', 'Online'],
  ['idle', 'AFK'],
  ['dnd', 'DND'],
  ['invisible', 'Offline'],
];

export function openStatusSettings() {
  try {
    window.__voxPendingSettingsTab = 'privacy';
    window.dispatchEvent(new CustomEvent('vox-open-settings', { detail: { tab: 'privacy', setting: 'status' } }));
  } catch {}
}

// Your own status dot, for the corner of your avatar.
export function MyStatusDot({ size = 10 }) {
  const p = usePresence();
  if (!p.me) return null;
  return <StatusDot status={p.me.status} size={size} ring className="vx-pres-avatar-dot" title={describeMine(p.me, Date.now(), p.skewMs)} />;
}

export default function QuickStatus({ onOpenSettings }) {
  const p = usePresence();
  const now = useNow(30000);
  const [busy, setBusy] = useState('');
  const [error, setError] = useState('');
  const cur = p.me ? p.me.status : '';
  const choose = async (s) => {
    setBusy(s);
    setError('');
    try {
      await setMyStatus(s, null);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy('');
    }
  };
  return (
    <div className="vx-pres-quickwrap" data-testid="quick-status">
      <div className="vx-pres-quick" role="radiogroup" aria-label="Your status">
        {QUICK.map(([s, label]) => (
          <button
            key={s}
            type="button"
            role="radio"
            aria-checked={cur === s}
            className={`vx-pres-quick-btn${cur === s ? ' is-on' : ''}`}
            disabled={!!busy}
            onClick={() => choose(s)}
            title={s === 'invisible' ? 'Appear offline' : label}
            data-testid={`quick-status-${s}`}
          >
            <StatusDot status={s} size={12} />
            {label}
          </button>
        ))}
      </div>
      <div className="vx-pres-quick-meta">
        {p.me ? describeMine(p.me, now, p.skewMs) : ''}{' '}
        <button
          type="button"
          className="vx-link-btn"
          onClick={() => {
            if (typeof onOpenSettings === 'function') onOpenSettings();
            else openStatusSettings();
          }}
          data-testid="quick-status-more"
        >
          Set a duration or message…
        </button>
      </div>
      {error ? (
        <div className="vx-acct-error" role="alert">
          {error}
        </div>
      ) : null}
    </div>
  );
}
